import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  HANDOVER_TYPE_AREA_REASON_7_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_8_OPE_TO_CWO_ID,
  HANDOVER_TYPE_HO3_ID,
  HANDOVER_TYPE_HOAC_ID,
  HANDOVER_TYPE_HLOC_ID,
  HANDOVER_TYPE_HLOC0_ID,
  HANDOVER_TYPE_HOEC_ID,
  HANDOVER_TYPE_HOG_ID,
  LIMIT_SEARCH_WELL,
  OFFSSET_SEARCH_WELL,
  OPERATIONAL_AREA_COMPLETION_ID,
  OPERATIONAL_AREA_DRILLING_ID,
  OPERATIONAL_AREA_OPERATIONS_ID,
  OPERATIONAL_AREA_PULLING_ID,
  PERMISSION_CREATE_HO_ID,
  PERMISSION_VIEW_HISTORY_HO,
  HANDOVER_TYPE_AREA_REASON_9_FAC_TO_DR_ID,
  MANAGEMENT_UNIT_ACA,
  MANAGEMENT_UNIT_HOC,
  PERMISSION_CREATE_HO_LOC,
  HANDOVER_TYPE_HO2_ID,
  HANDOVER_TYPE_HO1_ID,
  HANDOVER_TYPE_HOG_LOC_ID,
  HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_14_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_11_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_12_DRL_TO_CWO_ID,
  HANDOVER_TYPE_AREA_REASON_13_DRL_TO_DRL_ID,
  HANDOVER_TYPE_AREA_REASON_15_MC_TO_OPE_ID,
  HANDOVER_TYPE_HO5_ID,
} from 'src/app/handover-constants';
import { Handover, HandoversTotalCount } from 'src/app/interfaces/handover';
import { HandoverTypeAreaReason } from 'src/app/interfaces/handover-type-area-reason';
import {
  CurrentHandoverTypes,
  ResultWells,
  Well,
} from 'src/app/interfaces/well';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import { WellService } from 'src/app/services/well.service';
import { HoCreateMessages } from '../handover-initiate-messages';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-handover-initiate-well-list',
  templateUrl: './handover-initiate-well-list.component.html',
  styleUrls: ['./handover-initiate-well-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
  standalone: false,
})
export class HandoverInitiateWellListComponent implements OnInit {
  wells = new MatTableDataSource();
  handoverTypesArea: HandoverTypeAreaReason[] = [];
  handoverToOperations: HandoverTypeAreaReason[] = [];
  totalWells!: number;
  HotypeId!: number;
  handoverId: number | undefined;
  message!: string;
  searchText = '';
  isLoadingWells = false;
  hideFooter = true;
  havePermissionViewHoHistory = false;
  handoversCountToShow = 6;
  showHandoverHistoryHeader = true;
  handoversTotalCount = 0;
  titleInitiateHandoverButton: string[] = [];
  HOAC_TO_AREA_NAME = 'completar';
  HLOC0_TO_AREA_NAME = 'Drilling';
  HLOC_TO_AREA_NAME = 'Pulling';

  displayedColumns: string[] = [
    'wellCommonName',
    'project',
    'ug',
    'districtName',
    'lastHandover',
    'initiateHandover',
  ];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private wellService: WellService,
    private handoverService: HandoverService,
    private notificationService: NotificationService,
    private router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialogService: DialogService,
    private userService: UserService,
    private datePipe: DatePipe
  ) {
    this.matIconRegistry.addSvgIcon(
      'handover-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/handover-icon-white.svg'
      )
    );
  }

  ngOnInit(): void {
    this.getHandoverTypesArea();
    this.havePermissionViewHoHistory = this.userService.hasPermission(
      PERMISSION_VIEW_HISTORY_HO
    );
  }

  getHandoverTypesArea(): void {
    this.handoverService
      .getHandoverTypesArea()
      .subscribe((handoverTypesArea) => {
        for (let index = 0; index < handoverTypesArea.length; index++) {
          const element = handoverTypesArea[index];
          if (element.fromAreaId == OPERATIONAL_AREA_COMPLETION_ID) {
            if (this.userService.hasPermission(PERMISSION_CREATE_HO_LOC)) {
              if (this.isHandoverLocation(element.handoverTypeAreaReasonid)) {
                this.handoverToOperations.push(element);
              }
            } else {
              if (!this.isHandoverLocation(element.handoverTypeAreaReasonid)) {
                this.handoverToOperations.push(element);
              }
            }
          } else {
            if (element.handoverTypeId == HANDOVER_TYPE_HOAC_ID) {
              element.toAreaName = this.HOAC_TO_AREA_NAME;
            } else {
              if (element.handoverTypeId == HANDOVER_TYPE_HLOC0_ID) {
                element.toAreaName = this.HLOC0_TO_AREA_NAME;
              } else {
                if (element.handoverTypeId == HANDOVER_TYPE_HLOC_ID) {
                  element.toAreaName = this.HLOC_TO_AREA_NAME;
                }
              }
            }
            if (this.userService.hasPermission(PERMISSION_CREATE_HO_LOC)) {
              if (this.isHandoverLocation(element.handoverTypeAreaReasonid)) {
                this.handoverTypesArea.push(element);
              }
            } else {
              if (!this.isHandoverLocation(element.handoverTypeAreaReasonid)) {
                this.handoverTypesArea.push(element);
              }
            }
            this.HotypeId = HANDOVER_TYPE_HLOC_ID;
          }
        }
      });
  }

  getWells(searchText: string): void {
    this.isLoadingWells = true;
    this.wellService
      .getSearchWells(searchText, LIMIT_SEARCH_WELL, OFFSSET_SEARCH_WELL)
      .subscribe((res: ResultWells) => {
        this.isLoadingWells = false;
        this.wells = new MatTableDataSource();
        this.totalWells = res.totalWells;
        this.wells.data = res.wells;
        this.wells.paginator = this.paginator;
        this.hideFooter = res.wells.length > 0;
        this.wells.data.forEach(() => {
          this.titleInitiateHandoverButton.push('');
        });
        this.handoverService
          .getHandoversTotalCount()
          .subscribe((t: HandoversTotalCount) => {
            this.handoversTotalCount = t.totalAmount;
          });
      });
  }

  initiateHandover(
    well: Well,
    handoverTypeAreaId: number,
    handoverTypeName: string,
    handoverTypeId: number,
    fromAreaId: number
  ): void {
    this.isLoadingWells = true;
    if (
      !this.canInitiateHandover(
        handoverTypeId,
        well.currentHandoverTypes,
        well.existHogAccepted
      )
    ) {
      this.isLoadingWells = false;
      if (
        well.currentHandoverTypes &&
        well.currentHandoverTypes.filter(
          (hot) => hot.handoverTypeId == handoverTypeId
        ).length > 0
      ) {
        const currentHandoverType: CurrentHandoverTypes =
          well.currentHandoverTypes.filter(
            (hot) => hot.handoverTypeId == handoverTypeId
          )[0];
        this.notificationService.notify(
          `Ya existe un ${handoverTypeName} iniciado por ${currentHandoverType.handoverCreatorUser}. Para iniciar, no debe existir sobre este Pozo otro Handover en Gestión`,
          HoCreateMessages.ERROR_NOTIFICATION
        );
      } else {
        if (well.existHogAccepted) {
          this.notificationService.notify(
            `Ya existe un HOG aceptado sobre este pozo`,
            HoCreateMessages.ERROR_NOTIFICATION
          );
        }
      }
    } else {
      if (
        [
          HANDOVER_TYPE_HO3_ID,
          HANDOVER_TYPE_HOEC_ID,
          HANDOVER_TYPE_HOAC_ID,
          HANDOVER_TYPE_HLOC0_ID,
          HANDOVER_TYPE_HLOC_ID,
        ].includes(handoverTypeId)
      ) {
        this.initiateHandoverPostValidations(
          handoverTypeAreaId,
          well,
          handoverTypeName,
          handoverTypeId
        );
      } else {
        if (
          handoverTypeId == HANDOVER_TYPE_HOG_LOC_ID &&
          well.existHogLocAccepted
        ) {
          this.isLoadingWells = false;
          this.notificationService.notify(
            `Ya existe un HOG-LOC aceptado sobre este pozo`,
            HoCreateMessages.ERROR_NOTIFICATION
          );
        } else {
          this.handoverService
            .owValidation(
              well.uwi,
              this.handoverService.getHandoverInitiateValidationType(
                handoverTypeId,
                fromAreaId
              )
            )
            .subscribe((vt) => {
              if (!vt.validationResult) {
                this.isLoadingWells = false;
                this.notificationService.notify(
                  vt.rejectionMessage!,
                  HoCreateMessages.ERROR_NOTIFICATION
                );
              } else {
                this.initiateHandoverPostValidations(
                  handoverTypeAreaId,
                  well,
                  handoverTypeName,
                  handoverTypeId
                );
              }
            });
        }
      }
    }
  }

  private initiateHandoverPostValidations(
    handoverTypeAreaId: number,
    well: Well,
    handoverTypeName: string,
    handoverTypeId: number
  ) {
    let wellDistrict = '';
    if (well.districtName) {
      wellDistrict = well.districtName;
    }
    const handover = {
      handoverTypeAreaReasonId: handoverTypeAreaId,
      wellId: well.wellId,
      wellUwi: well.uwi,
      wellManagementUnit: well.ug,
      wellDistrict: wellDistrict,
      handoverType: handoverTypeName,
      handoverTypeId: handoverTypeId,
      wellProject: well.project,
      wellName: well.wellCommonName,
    } as Handover;

    const templateDate = 'dd/MM/yyyy';

    let fromOperationalArea: string | undefined;
    let toOperationalArea: string | undefined;
    let toOperationalAreaReason: string | undefined;

    fromOperationalArea = this.handoverTypesArea.find(
      (x) => x.handoverTypeAreaReasonid == handoverTypeAreaId
    )?.fromAreaName;

    if (!fromOperationalArea) {
      fromOperationalArea = this.handoverToOperations.find(
        (x) => x.handoverTypeAreaReasonid == handoverTypeAreaId
      )?.fromAreaName;
    }

    toOperationalArea = this.handoverTypesArea.find(
      (x) => x.handoverTypeAreaReasonid == handoverTypeAreaId
    )?.toAreaName;

    if (!toOperationalArea) {
      toOperationalArea = this.handoverToOperations.find(
        (x) => x.handoverTypeAreaReasonid == handoverTypeAreaId
      )?.toAreaName;
      toOperationalAreaReason = this.handoverToOperations.find(
        (x) => x.handoverTypeAreaReasonid == handoverTypeAreaId
      )?.reasonName;
    }

    if (!toOperationalAreaReason) {
      toOperationalAreaReason = '';
    }

    this.isLoadingWells = false;
    if (handover.handoverTypeId == HANDOVER_TYPE_HLOC_ID) {
      this.message = `¿Estás seguro que querés <b>iniciar el Handover de Locación de ${well.wellCommonName}</b> de <b>${fromOperationalArea} a ${toOperationalArea}?</b>?`;
    } else {
      this.message = `¿Estás seguro que querés <b>iniciar el Handover</b> del <b>Pozo ${well.wellCommonName}</b> de <b>${fromOperationalArea} a ${toOperationalArea} ${toOperationalAreaReason}</b>?`;
      if (
        handover.handoverTypeId == HANDOVER_TYPE_HLOC0_ID &&
        well.existHoloc0Accepted
      ) {
        const lastHoloc0AcceptedDate = this.datePipe.transform(
          well.lastHoloc0AcceptedDate,
          templateDate
        );
        this.message += `<br><b> Se realizará una copia del HLOC-0 aceptado el ${lastHoloc0AcceptedDate} </b>`;
      }
    }
    this.dialogService
      .openConfirmDialog('Iniciar Handover', `${this.message}`)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.isLoadingWells = true;
          this.handoverService.addHandover(handover).subscribe(
            (handover) => {
              if (handover) {
                this.isLoadingWells = false;
                this.notificationService.notify(
                  `${HoCreateMessages.ADD_NEW_HO_SUCCESS_INI} ${handover.handoverId} ${HoCreateMessages.ADD_NEW_HO_SUCCESS_END}`,
                  HoCreateMessages.SUCCESS_NOTIFICATION
                );
                this.handoverId = handover.handoverId;
                if (
                  (HANDOVER_TYPE_HO2_ID == handoverTypeId ||
                    HANDOVER_TYPE_HO1_ID == handoverTypeId ||
                    HANDOVER_TYPE_HOG_ID == handoverTypeId ||
                    HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID ==
                      handoverTypeAreaId ||
                    HANDOVER_TYPE_HO5_ID == handoverTypeId ||
                    this.isHandoverLocation(handoverTypeAreaId)) &&
                  this.handoverId
                ) {
                  this.handoverService
                    .updateHandoverRelation(this.handoverId)
                    .subscribe();
                }
                this.goToHandoverDetail(handover);
              } else {
                this.isLoadingWells = false;
                this.notificationService.notify(
                  `${HoCreateMessages.ADD_NEW_HO_ERROR_INI} \n${HoCreateMessages.ADD_NEW_HO_ERROR_END}`,
                  HoCreateMessages.ERROR_NOTIFICATION
                );
              }
            },
            (error: any) => {
              this.notificationService.notify(
                error.error.message,
                HoCreateMessages.ERROR_NOTIFICATION
              );
              this.isLoadingWells = false;
            }
          );
        }
      });
  }

  goToHandoverDetail(handover: Handover): void {
    this.router.navigateByUrl(`handover/${handover.handoverId}`, {
      state: { backTo: '' },
    });
    window.sessionStorage.removeItem('textSearch');
  }

  getSearchText(text: string): void {
    this.searchText = text;
    this.getWells(text);
  }

  getPage(event: PageEvent): void {
    this.isLoadingWells = true;
    const pageIndex = event.pageIndex + 1;
    this.wellService
      .getSearchWells(this.searchText, 10, pageIndex)
      .subscribe((res: ResultWells) => {
        this.isLoadingWells = false;
        this.wells = new MatTableDataSource();
        this.totalWells = res.totalWells;
        this.wells.data = res.wells;
        this.hideFooter = res.wells.length > 0;
      });
  }
  inititateHoButtonDisabled(
    districtId: number,
    haveOperationsReceivers: boolean,
    managementUnit: string,
    index: number
  ): boolean {
    let buttonDisabled = false;
    //Rule #2 and Rule #3
    if (
      this.userService.hasOperationalArea(OPERATIONAL_AREA_COMPLETION_ID) ||
      this.userService.hasOperationalArea(OPERATIONAL_AREA_PULLING_ID)
    ) {
      if (
        managementUnit != MANAGEMENT_UNIT_ACA &&
        managementUnit != MANAGEMENT_UNIT_HOC
      ) {
        buttonDisabled = !haveOperationsReceivers;
      } else {
        buttonDisabled = false;
      }

      if (buttonDisabled) {
        this.titleInitiateHandoverButton[index] =
          'Para iniciar, el Pozo debe pertenecer a un Distrito/Asset que coincida con el Perfil de algún Usuario de Operations';
      } else {
        this.titleInitiateHandoverButton[index] = '';
      }
    }
    return buttonDisabled;
  }

  inititateHoMenuButtonDisabled(
    haveOperationsReceivers: boolean,
    hoTypeArea: HandoverTypeAreaReason,
    wellInformation: Well
  ): boolean {
    let buttonMenuDisabled = false;
    //Rule #4
    if (
      this.userService.hasOperationalArea(OPERATIONAL_AREA_DRILLING_ID) &&
      hoTypeArea.toAreaId == OPERATIONAL_AREA_OPERATIONS_ID
    ) {
      buttonMenuDisabled = !haveOperationsReceivers;
    } // Rules for HOAC
    else if (
      hoTypeArea.handoverTypeAreaReasonid ==
      HANDOVER_TYPE_AREA_REASON_8_OPE_TO_CWO_ID
    ) {
      if (
        !wellInformation.existHoecAccepted || // #1
        !this.canInitiateHandover(
          // #2
          hoTypeArea.handoverTypeId,
          wellInformation.currentHandoverTypes,
          wellInformation.existHogAccepted
        )
      ) {
        buttonMenuDisabled = true;
      }
    }
    return buttonMenuDisabled;
  }

  titleInitiateHandoverMenuButton(
    haveOperationsReceivers: boolean,
    hoTypeArea: HandoverTypeAreaReason,
    wellInformation: Well
  ): string {
    //Rule #4
    let title = '';
    if (
      this.userService.hasOperationalArea(OPERATIONAL_AREA_DRILLING_ID) &&
      hoTypeArea.toAreaId == OPERATIONAL_AREA_OPERATIONS_ID
    ) {
      title = !haveOperationsReceivers
        ? 'Para iniciar, el Pozo debe pertenecer a un Distrito/Asset que coincida con el Perfil de algún Usuario de Operations'
        : '';
    } // Rules for HOAC
    else if (
      hoTypeArea.handoverTypeAreaReasonid ==
      HANDOVER_TYPE_AREA_REASON_8_OPE_TO_CWO_ID
    ) {
      if (!wellInformation.existHoecAccepted) {
        // #1
        title = 'Para iniciar, debe existir sobre este pozo un HOEC aprobado';
      } else if (
        !this.canInitiateHandover(
          hoTypeArea.handoverTypeId,
          wellInformation.currentHandoverTypes,
          wellInformation.existHogAccepted
        )
      ) {
        // #2
        if (
          wellInformation.currentHandoverTypes &&
          wellInformation.currentHandoverTypes.filter(
            (hot) => hot.handoverTypeId == hoTypeArea.handoverTypeId
          ).length > 0
        ) {
          const currentHandoverType: CurrentHandoverTypes =
            wellInformation.currentHandoverTypes.filter(
              (hot) => hot.handoverTypeId == hoTypeArea.handoverTypeId
            )[0];
          title = `Ya existe un ${hoTypeArea.type} iniciado por ${currentHandoverType.handoverCreatorUser}. Para iniciar, no debe existir sobre este Pozo otro Handover en Gestión`;
        }
      }
    }
    return title;
  }

  canInitiateHandover(
    handoverTypeId: number,
    currentHandoverTypes: CurrentHandoverTypes[] | undefined,
    existHogAccepted: boolean
  ): boolean {
    let canInitiateHo = false;
    //Rules #5, #6, #7, #8, #9, #10, #11, #12, #13
    if (currentHandoverTypes) {
      canInitiateHo =
        currentHandoverTypes.filter(
          (hot) => hot.handoverTypeId == handoverTypeId
        ).length == 0 &&
        (handoverTypeId == HANDOVER_TYPE_HOG_ID ? !existHogAccepted : true);
    } else {
      canInitiateHo =
        handoverTypeId == HANDOVER_TYPE_HOG_ID ? !existHogAccepted : true;
    }
    return canInitiateHo;
  }

  havePermissionCreate(managementUnit: string): boolean {
    return this.userService.hasPermissionAndManangementUnit(
      PERMISSION_CREATE_HO_ID,
      managementUnit
    );
  }

  isInitiateHandoverToOperationsDisabled(
    hoBeingInitiated: HandoverTypeAreaReason,
    wellInformation: Well
  ): boolean {
    // Rules for HOEC
    if (
      hoBeingInitiated.handoverTypeAreaReasonid ==
      HANDOVER_TYPE_AREA_REASON_7_CWO_TO_OPE_ID
    ) {
      // #1, #2, #4
      return (
        !wellInformation.existHo1Accepted ||
        !wellInformation.districtId ||
        !this.canInitiateHandover(
          hoBeingInitiated.handoverTypeId,
          wellInformation.currentHandoverTypes,
          wellInformation.existHogAccepted
        )
      );
    }
    return false;
  }

  initiateHandoverToOperationsTitle(
    hoBeingInitiated: HandoverTypeAreaReason,
    wellInformation: Well
  ): string {
    // Rules for HOEC
    if (
      hoBeingInitiated.handoverTypeAreaReasonid ==
      HANDOVER_TYPE_AREA_REASON_7_CWO_TO_OPE_ID
    ) {
      if (!wellInformation.existHo1Accepted) {
        // #1
        return 'Para iniciar, debe existir sobre este pozo un HO1 aprobado';
      } else if (!wellInformation.districtId) {
        // #2
        return 'Para iniciar, el pozo debe tener un Distrito/Asset asociado, revisar sistema origen de datos';
      } else if (
        // #4
        !this.canInitiateHandover(
          hoBeingInitiated.handoverTypeId,
          wellInformation.currentHandoverTypes,
          wellInformation.existHogAccepted
        )
      ) {
        if (
          wellInformation.currentHandoverTypes &&
          wellInformation.currentHandoverTypes.filter(
            (hot) => hot.handoverTypeId == hoBeingInitiated.handoverTypeId
          ).length > 0
        ) {
          const currentHandoverType: CurrentHandoverTypes =
            wellInformation.currentHandoverTypes.filter(
              (hot) => hot.handoverTypeId == hoBeingInitiated.handoverTypeId
            )[0];
          return `Ya existe un ${hoBeingInitiated.type} iniciado por ${currentHandoverType.handoverCreatorUser}. Para iniciar, no debe existir sobre este Pozo otro Handover en Gestión`;
        }
      }
    }
    return '';
  }

  isHandoverLocation(handoverTypeAreaReasonId: number): boolean {
    return [
      HANDOVER_TYPE_AREA_REASON_11_CWO_TO_OPE_ID,
      HANDOVER_TYPE_AREA_REASON_12_DRL_TO_CWO_ID,
      HANDOVER_TYPE_AREA_REASON_13_DRL_TO_DRL_ID,
      HANDOVER_TYPE_AREA_REASON_14_CWO_TO_OPE_ID,
      HANDOVER_TYPE_AREA_REASON_15_MC_TO_OPE_ID,
    ].includes(handoverTypeAreaReasonId);
  }
}
